/***************************************************************
6/19/2017
Alexander Self
Signin component
- Simple form for users to signin
***************************************************************/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import * as actions from '../../actions';
import Preloader from '../../components/preloader';
class SignIn extends Component {
  constructor(props) {
    super(props);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }
  componentDidMount() {
    if (this.props.authenticated) {
      browserHistory.push('/dashboard');
    }
  }
  handleFormSubmit(e) {
    e.preventDefault();
    const email = document.getElementById('signin-email').value;
    const password = document.getElementById('signin-password').value;
    this.props.signinUser({email, password});
  }
  render() {
    return (
      <div className="container signin">
        <div className="row">
          <div className="col s12 m2 l3"></div>
          <div className="col s12 m8 l6">
            <div id="preloader"><center><Preloader /></center></div>
            <div className="card signin z-depth-5">
              <center><div className="card-title">Signin</div></center><hr />
              <form onSubmit={(e) => this.handleFormSubmit(e)}>
                <div className="signin-input">
                  <label htmlFor="signin-email">Email:</label>
                  <input type="text" id="signin-email" />
                </div>
                <div className="signin-input">
                  <label htmlFor="signin-password">Password:</label>
                  <input type="password" id="signin-password" />
                </div>
                <center><button action="submit" className="btn btn-large">Sign In</button></center>
                <br />
              </form>
            </div>
          </div>
          <div className="col s12 m2 l3"></div>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    errorMessage: state.auth.error,
    authenticated: state.auth.authenticated
  };
}


export default connect(mapStateToProps, actions)(SignIn);
































/* END */



// WEBPACK FOOTER //
// ./src/containers/auth/signin.js